/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PropsWithChildren } from "react";
import styled, { css } from "styled-components";
import { theme } from "@nordcloud/gnui";

type ContainerProps = PropsWithChildren<
  ContainerRowProps & {
    justifyContent?: string;
    marginBottom?: string;
    width?: string;
  }
>;

type ContainerRowProps = {
  hasBorder?: boolean;
  showBorderOnLastItem?: boolean;
};

/* stylelint-disable no-descending-specificity */
function getBorderCss(showBorder: boolean, showBorderOnLastItem: boolean) {
  const lastItemBorder = showBorderOnLastItem
    ? `1px solid ${theme.color.border.border01}`
    : "none";

  return showBorder
    ? css`
        > div {
          border-right: 1px solid ${theme.color.border.border01};

          &:last-of-type {
            border-right: ${lastItemBorder};
          }
        }
      `
    : css`
        > div {
          border-right: none;
        }
      `;
}

const ContainerRow = styled.div<ContainerRowProps>`
  display: flex;
  flex-wrap: wrap;

  ${({ hasBorder, showBorderOnLastItem }) =>
    getBorderCss(hasBorder ?? false, showBorderOnLastItem ?? false)};
`;

export function DataContainer({
  children,
  hasBorder = true,
  showBorderOnLastItem = false,
  justifyContent = "flex-start",
  marginBottom = theme.spacing.spacing04,
  width,
}: ContainerProps) {
  return (
    <ContainerRow
      hasBorder={hasBorder}
      showBorderOnLastItem={showBorderOnLastItem}
      css={{ justifyContent, marginBottom, width }}
    >
      {children}
    </ContainerRow>
  );
}
